// import { useState, useContext } from "react";
// import { useNavigate } from "react-router-dom";
// import Swal from "sweetalert2";
// import axios from "axios";
// import { AuthContext } from "./AuthContext";

// export default function Login() {
//   const [email, setEmail] = useState("");
//   const [otp, setOtp] = useState("");
//   const [isOtpGenerated, setIsOtpGenerated] = useState(false);
//   const [isButtonDisabled, setIsButtonDisabled] = useState(false); // New state for disabling the button
//   const navigate = useNavigate();
//   const { login } = useContext(AuthContext);

//   const generateOtpHandle = async () => {
//     setIsButtonDisabled(true); // Disable the button
//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_BASE_URL}/api/v1/user/login`,
//         {
//           email,
//         }
//       );

//       if (response.status === 200) {
//         Swal.fire("OTP sent", "Please check your email for the OTP", "success");
//         setIsOtpGenerated(true);
//       } else {
//         Swal.fire("Failed to send OTP", "Please try again", "error");
//       }
//     } catch (error) {
//       console.error("Error generating OTP:", error);
//       Swal.fire(
//         "Failed to send OTP",
//         "An error occurred. Please try again later.",
//         "error"
//       );
//     } finally {
//       // Enable the button after 10 seconds
//       setTimeout(() => {
//         setIsButtonDisabled(false);
//       }, 20000); // 10 seconds delay
//     }
//   };

//   const loginHandle = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_BASE_URL}/api/v1/user/verifyLoginOTP`,
//         {
//           email,
//           otp,
//         }
//       );

//       if (response.status === 200) {
//         const { token, user } = response.data; // Assuming 'user' contains user details
//         console.log("User Role:", user?.id_role?.role_title); // Console log role title

//         Swal.fire("Login success", "", "success");
//         login(response.data.token);
//         localStorage.setItem("token", response.data.token);
//         localStorage.setItem("userRole", response.data.user.id_role.role_title); // Store role
//         localStorage.setItem(
//           "staffRole",
//           response.data.user.id_generalStaffType.name
//         ); // Store Staff Type

//         navigate("/");
//       } else {
//         Swal.fire("Login failed", "Please check your credentials", "error");
//       }
//     } catch (error) {
//       console.error("Error logging in:", error);
//       Swal.fire(
//         "Login failed",
//         "An error occurred. Please try again later.",
//         "error"
//       );
//     }
//   };

//   return (
//     <div>
//       <div
//         style={{
//           // backgroundImage: `url('/dashboard2.png')`,
//           backgroundImage: `url('/loginpage.png')`,

//           backgroundSize: "cover",
//           height: "100vh",
//           display: "flex",
//           justifyContent: "flex-end",
//           alignItems: "center",
//         }}
//       >
//         <div style={{ width: "30%", marginRight: "5%" }}>
//           <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
//             <div className="card-header border-bottom text-center">
//               <h1>
//                 <b>Login</b>
//               </h1>
//             </div>
//             <div className="card-body">
//               <input
//                 type="text"
//                 placeholder="Enter Your Email"
//                 className="form-control"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//               />
//               <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
//                 <button
//                   type="button"
//                   onClick={generateOtpHandle}
//                   className="btn btn-secondary"
//                   disabled={isButtonDisabled} // Disable button based on state
//                 >
//                   {isButtonDisabled ? "Please wait..." : "Generate OTP"}{" "}
//                   {/* Show waiting text */}
//                 </button>
//                 <button
//                   type="submit"
//                   onClick={loginHandle}
//                   className="btn btn-primary"
//                 >
//                   Login
//                 </button>
//               </div>
//               {isOtpGenerated && (
//                 <>
//                   <input
//                     type="text"
//                     placeholder="Enter OTP"
//                     className="form-control my-3"
//                     value={otp}
//                     onChange={(e) => setOtp(e.target.value)}
//                   />
//                 </>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

//splitting
import { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import { AuthContext } from "./AuthContext";
export default function Login() {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [isOtpGenerated, setIsOtpGenerated] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const generateOtpHandle = async () => {
    setIsButtonDisabled(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v1/user/login`,
        { email }
      );

      if (response.status === 200) {
        Swal.fire("OTP sent", "Please check your email for the OTP", "success");
        setIsOtpGenerated(true);
      } else {
        Swal.fire("Failed to send OTP", "Please try again", "error");
      }
    } catch (error) {
      console.error("Error generating OTP:", error);
      Swal.fire(
        "Failed to send OTP",
        "An error occurred. Please try again later.",
        "error"
      );
    } finally {
      setTimeout(() => setIsButtonDisabled(false), 20000);
    }
  };
  const loginHandle = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v1/user/verifyLoginOTP`,
        { email, otp }
      );

      if (response.status === 200) {
        const { token, user } = response.data;

        // ✅ WAIT for alert to complete
        await Swal.fire({
          title: "Login Success",
          text: "Welcome to Trackk!",
          icon: "success",
          confirmButtonText: "Continue",
        });

        // ✅ AFTER user clicks OK → THEN login & navigate
        login(token);
        localStorage.setItem("token", token);
        localStorage.setItem("userRole", user.id_role.role_title);
        localStorage.setItem("staffRole", user.id_generalStaffType.name);
        localStorage.removeItem("hasSeenTrackk");

        navigate("/"); // ✅ NOW it navigates
      } else {
        await Swal.fire(
          "Login failed",
          "Please check your credentials",
          "error"
        );
      }
    } catch (error) {
      console.error("Error logging in:", error);

      // ✅ WAIT for error alert also
      await Swal.fire(
        "Login failed",
        "An error occurred. Please try again later.",
        "error"
      );
    }
  };

  // const loginHandle = async (e) => {
  //   e.preventDefault();
  //   try {
  //     const response = await axios.post(
  //       `${process.env.REACT_APP_BASE_URL}/api/v1/user/verifyLoginOTP`,
  //       { email, otp }
  //     );

  //     if (response.status === 200) {
  //       const { token, user } = response.data;
  //       Swal.fire("Login success", "", "success");
  //       login(token);
  //       localStorage.setItem("token", token);
  //       localStorage.setItem("userRole", user.id_role.role_title);
  //       localStorage.setItem("staffRole", user.id_generalStaffType.name);
  //       localStorage.removeItem("hasSeenTrackk");

  //       // navigate("/flow");
  //       navigate("/");
  //     } else {
  //       Swal.fire("Login failed", "Please check your credentials", "error");
  //     }
  //   } catch (error) {
  //     console.error("Error logging in:", error);
  //     Swal.fire(
  //       "Login failed",
  //       "An error occurred. Please try again later.",
  //       "error"
  //     );
  //   }
  // };
  useEffect(() => {
    document.body.classList.add("login-page");

    return () => {
      document.body.classList.remove("login-page");
    };
  }, []);
  return (
    <div
      style={{
        display: "flex",
        height: "100dvh",
        width: "100vw",
        fontFamily: "Poppins, sans-serif",
      }}
    >
      <div
        style={{
          flex: 1,
          height: "100%", // ✅ Add this
          backgroundImage: `url('/logincontent.png')`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat", // ✅ Add this
          backgroundPosition: "center", // ✅ Fix typo: from 'centre' to 'center'
        }}
      />

      {/* Right Side Form */}
      <div
        style={{
          flex: 1,
          backgroundColor: "#fff",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            height: "100%",
            padding: "190px 130px ",
            borderRadius: "12px",
            boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.05)",
          }}
        >
          {/* Header Section */}
          <div style={{ marginBottom: "20px" }}>
            <img
              src="/pickkup.png"
              alt="Logo"
              style={{ height: "60px", marginBottom: "10px" }}
            />
            <br />
            <br />
            <h1 style={{ fontWeight: "700", margin: 0 }}>
              Welcome! <span style={{ fontWeight: "400" }}>back!</span>
            </h1>
            <h3 style={{ color: "#777", marginTop: "10px" }}>
              Trackk is your all-in-one logistics platform for tracking
              vehicles, users, compliance, and revenue. Manage reports, payouts,
              orders, and adhoc data — all from one seamless dashboard.
            </h3>
          </div>
          <br />
          {/* Email Input */}
          <input
            type="email"
            placeholder="ENTER YOUR EMAIL ID"
            className="form-control mb-3"
            style={{ width: "100%" }}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          {/* OTP Input */}
          {isOtpGenerated && (
            <input
              type="text"
              placeholder="Enter OTP"
              className="form-control mb-3"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
          )}
          <br />
          {/* Buttons */}
          <div style={{ display: "flex", gap: "15px" }}>
            <button
              type="button"
              onClick={generateOtpHandle}
              className="btn btn-warning"
              style={{
                width: "100%",
                backgroundColor: "#FFEAC2",
                color: "#000",
              }}
              disabled={isButtonDisabled}
            >
              {isButtonDisabled ? "Please wait..." : "GENERATE OTP"}
            </button>

            <button
              type="submit"
              onClick={loginHandle}
              className="btn btn-warning"
              style={{
                width: "100%",
                backgroundColor: "#F9B233",
                color: "#fff",
              }}
            >
              LOGIN NOW
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
